<template>
  <v-dialog
      v-model="isOpen"
      :width="$route.name === 'Closures-list' ? 900 : 700"
      @click:outside="closeModal"
      style="z-index:1000"
    >
      <v-card class="d-flex flex-column align-items-center p-2">
        <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
        <v-card-title class="mb-4">Serviço: {{service.code}}</v-card-title>
        <v-card-text>
          <the-table 
            :dataItems="service.animals"
            :headers="headersForAnimalsTable"
          >
            <template v-slot:situationHeader>
              <span class="d-flex justify-content-center">Situação</span>
            </template>
            <template v-slot:situation="{item}">
              <span class="d-flex justify-content-center">{{formatStatus(item.status)}}</span>
            </template>
          </the-table>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import TheTable from "@/components/layout/TheTable";
export default {
  name:"ModalServiceAnimals",
  components:{
    TheTable
  },
  props:{
    service:Object,
    isOpen:Boolean
  },
  data() {
    return {
      headersForAnimalsTable:[
        {text:"Registro", value:"register", sortable:true},
        {text:"Situação", value:"situation", has_slot:true, header_slot:"situationHeader", sortable:true},
        {text:"Animal", value:"name", sortable:true},
        {text:"Botton", value:"code", sortable:true},
        {text:"Composição Racial", value:"degree_blood", sortable:true},
      ]
    }
  },
  methods: {
    formatStatus(status) {
      return !status || (!status.description && !status.title) ? "-" : `${status.description || "-"} - ${status.title || "-"}`;
    },
    closeModal() {
      this.$emit("close");
    }
  },
  mounted() {
    if(this.$route.name === "Closures-list") {
      this.headersForAnimalsTable = [
        {text:"Animal", value:"name", sortable:true},
        {text:"Registro", value:"register", sortable:true},
        {text:"Data", value:"date_explanation", sortable:true},
        {text:"Motivo da Baixa", value:"kind_closure", sortable:true}
      ]
    }
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>
